import { render, staticRenderFns } from "./Trading.vue?vue&type=template&id=d4cd0e9a&scoped=true&"
import script from "./Trading.vue?vue&type=script&lang=js&"
export * from "./Trading.vue?vue&type=script&lang=js&"
import style0 from "./Trading.vue?vue&type=style&index=0&lang=scss&rel=stylesheet%2Fscss&"
import style1 from "./Trading.vue?vue&type=style&index=1&id=d4cd0e9a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4cd0e9a",
  null
  
)

export default component.exports